import H from '@here/maps-api-for-javascript';
import { AREA_TYPES } from 'utils/territories/TerritoriesFromJson';
import { colors, tourColors } from 'global/variables';

const { areas, avoidArea, transparentDarkerColor } = colors;
const FILL_ALPHA = '33';

const getAreaStyle = (feature) => {
  const { index, type } = feature.properties || {};
  const safeIndex = typeof index === 'number' ? index : 0;
  const isAvoid = type === AREA_TYPES.AVOID_AREA;
  const isExclude = type === AREA_TYPES.EXCLUDE_AREA;
  const isGroup = type === AREA_TYPES.GROUP;
  const isTourHull =
    type === AREA_TYPES.TOUR_HULL_CONCAVE || type === AREA_TYPES.TOUR_HULL_CONVEX;

  const tourColor = tourColors[safeIndex % tourColors.length].delivery.inner;
  const baseColor =
    isAvoid || isExclude ? avoidArea : isTourHull ? tourColor : areas[safeIndex % areas.length];
  const strokeColor =
    isAvoid || isExclude ? avoidArea : isTourHull ? tourColor : transparentDarkerColor;
  const lineDash =
    isGroup || isAvoid || isExclude ? [4, 4] : isTourHull ? [20, 20] : [];

  return {
    fillColor: baseColor + FILL_ALPHA,
    strokeColor,
    lineWidth: 2,
    lineDash,
  };
};

const buildExterior = (ring) => {
  const lineString = new H.geo.LineString();
  ring.forEach(([lng, lat]) => lineString.pushLatLngAlt(lat, lng, 0));
  return lineString;
};

const buildPolygonFromRings = (rings, style, properties) => {
  const exterior = buildExterior(rings[0]);
  const interiors = rings.slice(1).map(buildExterior);
  const polygon = new H.map.Polygon(new H.geo.Polygon(exterior, interiors), { style, volatility: true });
  polygon.setData(properties);
  return polygon;
};

export const buildAreaPolygons = (features) =>
  features.flatMap((feature) => {
    const { coordinates, type } = feature.geometry;
    const style = getAreaStyle(feature);

    if (type === 'MultiPolygon') {
      return coordinates.map((rings) => buildPolygonFromRings(rings, style, feature.properties));
    }

    return [buildPolygonFromRings(coordinates, style, feature.properties)];
  });

